import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import styles from "./oos-affiliate-hero-card.css";

interface OosHeroCardButtonProps {
    link: string;
    link_text: string;
    event_label: string;
}

export function OosHeroCardButton({
    link,
    link_text: linkText,
    event_label: eventLabel,
}: OosHeroCardButtonProps): JSX.Element {
    function handleClick(): void {
        analytics.event("oos_afilliate", "hero_card", eventLabel);
    }

    return (
        <a href={link} onClick={handleClick} role="button" className={styles.button}>
            <SVGIcon name="hyperlink" />
            <span>{linkText}</span>
        </a>
    );
}

export interface OosHeroCardProps {
    buttons: OosHeroCardButtonProps[];
}

function OosHeroCard({ buttons }: OosHeroCardProps): JSX.Element {
    return (
        <div>
            {buttons &&
                buttons.map((button) => <OosHeroCardButton key={button.link} {...button} />)}
        </div>
    );
}

export default OosHeroCard;
